"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analysis = analysis;
exports.questions = void 0;
var questions = [{
  prompt: "",
  extraText: "What is your unhelpful thought?",
  placeholder: "Write your unhelpful thought here…",
  tips: "TIPS: Choose a thought that isn't helping you in life. For example: \"I'll get it wrong\" or \"I just got lucky\", \"I'm not that talented\" or \"I'm an ineffective manager\". The best thoughts to work with are thoughts that start with \"I am...\" or \"I have to...\" or \"I can't...\". Thoughts that are predictions about the future like \"If I don't ____, then something bad will happen\" are also good to challenge.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "Does this thought help you in any way?",
  placeholder: "Write reasons why the thought is unhelpful here...",
  tips: "TIPS: The more reasons you can find why the thought is unhelpful, the more effective this exercise will be. When you believe this thought, how does it make you feel? How does it make you act? How does it make you treat yourself or treat others?",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "Is this thought absolutely true?",
  placeholder: "Write reasons why the thought is not 100% true here...",
  tips: "TIPS: Why is this thought not 100% true in all situations at all times? What is the opposite of this thought? Write down some times when the opposite of this thought was true. Why is this thought not 100% accurate? The more evidence you write down, the more effective this exercise will be.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What is a better way of thinking about this?",
  placeholder: "Write a better way here to think about this here...",
  tips: "TIPS: This can be a new, positive and helpful thought to replace your old mindset about this situation. Or write a one sentence summary of your answers to the previous questions.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What is the next thought you need to retrain?",
  placeholder: "Write down any reasons why the thought still feels true here...",
  type: "multirow",
  tips: "TIPS: It’s normal to retrain a thought but it still feels partly true. That’s because there are related thoughts that need to be trained. Unhelpful thoughts occur in clusters of related thoughts that make up a belief system. To identify the next thought in the cluster, ask yourself: Why does my unhelpful thought still feel true? Write down any reasons you think of. These unhelpful thoughts are the next ones that you’ll need to retrain to change your mindset.",
  aggregated: true
}];
exports.questions = questions;

function analysis(answers) {
  return {
    answers: answers.slice(0, 4),
    rootThought: answers[4]
  };
}

;